import { useLocation } from "infrastructure/router";
import { compareIds } from "util/support";

export const useStep = () => {
    const location = useLocation();

    const getCurrentStep = () => String(
        location.pathname.split('/')
            .pop()
    );

    const isCurrentStep = (step: string | number) => compareIds(getCurrentStep(), step);

    return {
        isCurrentStep,
        getCurrentStep
    };
};

export default useStep;
